/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    import AlarmConfigType = Models.AlarmConfigType;
    import IAlarmLevel = Models.IAlarmLevel;
    import IParamOption = Models.IParamOption;

    /**
     * Factory callback type
     */
    declare type AlarmsLevelsDirectiveFactoryCb = ($rootScope: ng.IRootScopeService,
                                                   $timeout: ng.ITimeoutService,
                                                   $window: ng.IWindowService,
                                                   stompService: Services.StompService,
                                                   alarmsService: Services.AlarmsService) => AlarmsLevelsDirective;

    export interface IAlarmsLevelsDirectiveScopeDef {
        index: string;
        type: string;
        level: string;
        masked: string;
        enabled: string;
        options: string;
        paramName: string;
    }

    export interface IAlarmsLevelsDirectiveScope extends ng.IScope {
        index: number;
        type: AlarmConfigType;
        level: IAlarmLevel;
        masked: boolean;
        enabled: boolean;
        options: IParamOption[];
        paramName: string;

        getSeverityColor: (severity: number) => string;
        update: (level: IAlarmLevel) => void;
    }

    export class AlarmsLevelsDirective implements ng.IDirective {
        public static $name: string = "alarmsLevels";

        public link: ($scope: IAlarmsLevelsDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'E';
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/alarms-levels-directive.html';
        public scope: IAlarmsLevelsDirectiveScopeDef = {
            index: '@',
            type: '=',
            level: '=',
            masked: '=',
            enabled: '=',
            options: '=',
            paramName: '=',
        };

        public static Factory(): AlarmsLevelsDirectiveFactoryCb {
            let directive: AlarmsLevelsDirectiveFactoryCb = ($rootScope: IFlexRootScope,
                                                             $timeout: ng.ITimeoutService,
                                                             $window: ng.IWindowService,
                                                             stompService: Services.StompService,
                                                             alarmsService: Services.AlarmsService) => {
                return new AlarmsLevelsDirective($rootScope, $timeout, $window, stompService, alarmsService);
            };
            directive.$inject = ['$rootScope', '$timeout', '$window', 'stompService', 'alarmsService'];
            return directive;
        }

        constructor($rootScope: IFlexRootScope,
                    $timeout: ng.ITimeoutService,
                    $window: ng.IWindowService,
                    stompService: Services.StompService,
                    alarmsService: Services.AlarmsService) {

            AlarmsLevelsDirective.prototype.link = ($scope: IAlarmsLevelsDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                $scope.getSeverityColor = (severity: number): string => {
                    return alarmsService.getSeverityColor(severity);
                };

                $scope.update = (level: IAlarmLevel) => {
                    $scope.level.value = level.value;
                };
            };
        }
    }
}
